import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PlanDetailSchema } from './shapes';

export const getReleasePlan = defineEndpoint({
  method: 'GET',
  path: '/v1/release-plans/:planId',
  params: z.object({ planId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: PlanDetailSchema }),
});
